import { doMutation } from "../../core-module/util/graphqlHelper";

export const deleteOrganization = id => {
  const mutation = require("../api/mutation/deleteOrganization.gql");
  const variables = {
    id: id,
  };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) return { data: data.deleteOrganization };
    else if (error) return { error: JSON.stringify(error) };
  });
};
